import "@babel/polyfill";
import Vue from "vue";
import VueI18n from "vue-i18n";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faBan
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import App from "./App";
import router from "./router";
import store from "./store";
import en from "./languages/en-gb";
import fr from "./languages/fr-be";
import nl from "./languages/nl-be";
import de from "./languages/de-de";

library.add(
  faCheck,
  faBan
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueI18n);

const messages = {
  "en-gb": en,
  "fr-be": fr,
  "nl-be": nl,
  "de-de": de
};
if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "en-gb");
}

const i18n = new VueI18n({
  locale: localStorage.getItem("language"), // set locale
  messages,
  fallbackLocale: "en-gb"
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
